import { translate } from '@repo/phrase';
import { NoBodyMessage } from '@repo/ui/message';

import { LoadingPage } from '@/components/loading';
import { QueryError } from '@/components/query-error';
import { ServicesTable } from '@/components/services-table';

import { useAssetServices } from '@/hooks/asset-services.hooks';
import { useAsset, useAssetParams } from '@/hooks/asset.hooks';

export const AssetServicesTable = () => {
    const { assetId, assetType } = useAssetParams();
    const { data, isError, isLoading, error } = useAsset(assetType, assetId);
    const services = useAssetServices(data);

    if (isError && !data) {
        return <QueryError error={error} />;
    }
    if (isLoading) {
        return <LoadingPage />;
    }

    if (!data) {
        return null;
    }

    if (services.length === 0) {
        return (
            <NoBodyMessage
                title={translate('services_not_found_title')}
                body={translate('services_not_found_body')}
                iconAriaLabel={translate('services_not_found_icon')}
                headingLevel="2"
            />
        );
    }

    return <ServicesTable services={services} />;
};
